import { useMemo } from "react";
import { useLocation } from "react-router";

import { CommonPaths } from "../../paths";

import { useTasksStateContext } from "./context";

export const useTasksGuard = () => {
  const { hasPendingTasks, isLoading, isCompleted, isFetched, isError } =
    useTasksStateContext();

  const location = useLocation();

  const shouldRedirect = useMemo(
    () =>
      (hasPendingTasks || isError) && location.pathname !== CommonPaths.Welcome,
    [hasPendingTasks, isError, location.pathname],
  );

  return {
    shouldRedirect,
    shouldShowLoader: isLoading || (!isFetched && !isCompleted),
  };
};
